import { createAsyncThunk } from '@reduxjs/toolkit'
import { BoughServiceByTimeSchedule } from '@/models/quote'
import { Service, TimeSchedule } from '@/models/service'
import { cartSlice } from '@/store/cartSlice'
import { RootState } from '@/store/configureStore.ts'
import { groupByTimeSchedule } from '@/utils/timeSchedules'

/* 
  increase or decrease of the service configuration of our selectedElement.
  Changing the configuration of selectedElement will trigger a new /quote action
  and will update the final price preview for the user to see
*/
export const cartChangeQuotableServiceQuantity = createAsyncThunk<
  void,
  {
    service: Service
    days: number[]
    timeSchedules: {
      bought: number
      timeSchedule: TimeSchedule
    }[]
  },
  { state: RootState }
>('cart/cartChangeQuotableServiceQuantity', async (action, thunkAPI) => {
  const { dispatch, getState } = thunkAPI
  const rootState = getState()
  const selectedElementQuotableProducts =
    cartSlice.selectors.selectedElementQuotableProducts(rootState)

  const boughtServices =
    action.timeSchedules.reduce<BoughServiceByTimeSchedule>((acc, item) => {
      return {
        ...acc,
        ...groupByTimeSchedule(
          item.timeSchedule,
          item.bought,
          action.days,
          action.service
        ),
      }
    }, {})

  const updatedProducts = {
    ...selectedElementQuotableProducts,
    boughtServices: {
      ...selectedElementQuotableProducts.boughtServices,
      [action.service.serviceId]: boughtServices,
    },
    services: {},
  }

  dispatch(
    cartSlice.actions.setSelectedElementQuotableProducts(updatedProducts)
  )
})
